module.exports = __webpack_public_path__ + "static/media/loading-animated.10614d51.svg";